/**
 * menu初始化配置数据
 * STYLE：导航样式相关
 * INFO：系统名称、logo图片地址
 * DEAULTMENU：默认打开页面
 * PATHMAP：存放payh与menu对象的映射，方便页面跳转
 */
const STYLE = {
  isTop: false,
  isTab: false,
  theme: "light", //light\dark
  backgroundColor: "#fff",
  color: "#333"
  // activeTextColor: "#ffd04b",
  // activeBacground:"#1C60C6",
};
const INFO = {
  name: "中国通用技术集团-中心采购平台",
  logo: ""
};
const DEAULTMENU = {
  // isCheck: "",
  // menuCode: "MENU02012",
  // menuName: "菜单二",
  // modified: "",
  // path: "bill-issue/payable2",
  // updateTime: null,
  // cannotClose:true
};

const PATHMAP = {};

export default {
  STYLE,
  INFO,
  DEAULTMENU,
  PATHMAP
};



// WEBPACK FOOTER //
// ./src/config/menu-config.js